import React, { useState, useEffect, useRef } from 'react';
import FilterPopup from './FilterPopup';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { useDispatch } from 'react-redux';
import { setCommonData } from '../../../core/Features/commonSlice';

interface CardProps {
    emoji: string;
    label: string;
    onClick: () => void;
    destination?: boolean;
    heightVal?: number;
    widthval?: number
}

interface StudyItem {
    emoji: string;
    label: string;
}

// const studyLevels: StudyItem[] = [
//     { emoji: '🏫', label: 'School' },
//     { emoji: '🎓', label: 'Pre-Degree & Vocational' },
//     { emoji: '📚', label: 'Foundation' },
//     { emoji: '👨‍🎓', label: 'Undergraduate' },
//     { emoji: '🧑', label: 'Postgraduate' },
//     { emoji: '📜', label: 'Doctorate' },
//     { emoji: '🔧', label: 'VET' },
// ];

// const studyDestinations: StudyItem[] = [
//     { emoji: '🏫', label: 'Australia' },
//     { emoji: '🎓', label: 'Spain' },
//     { emoji: '📚', label: 'United Kingdom' },
//     { emoji: '👨‍🎓', label: 'Canada' },
//     { emoji: '🇺🇸', label: 'United States' },
//     { emoji: '🇮🇪', label: 'Ireland' },
// ];

// Card Component
const Card: React.FC<CardProps> = ({ emoji, label, onClick, destination = false, heightVal = 24, widthval = 24 }) => (
    <button
        onClick={onClick}
        className="flex w-full items-start justify-start p-3 rounded-xl shadow-md bg-white transition hover:shadow-lg"
    >
        <div className="flex flex-col items-start gap-4">
            <div>
                <ImageWithBasePath
                    // className="rounded-circle"
                    className={`object-cover ${destination ? 'rounded-full' : ''}`}
                    style={{ width: widthval, height: heightVal }}
                    height={heightVal}
                    width={widthval}
                    source={emoji || "./assets/img/feature/feature-1.jpg"}
                    alt="img"
                />

            </div>
            <div className="flex items-center gap-2">
                <span className="font-medium text-[#191919]">{label}</span>
                <span className="text-[#191919] font-lg">›</span>
            </div>
        </div>
    </button>
);

// Main Component

interface BannerProps {
    apiValues: any;
}



const ScholarshipsBrowse: React.FC<BannerProps> = ({ apiValues }) => {
    const modalRef = useRef<HTMLDivElement>(null);

    const [selectedCountries, setSelectedCountries] = useState<string[]>([]);
    const [selectedLevels, setSelectedLevels] = useState<string[]>([]);
    const [selectedAll, setSelectedAll] = useState<Record<string, string[]>>({});

    const [selectedCard, setSelectedCard] = useState<StudyItem | null>(null);
    const dispatch = useDispatch()

    const closeModal = () => setSelectedCard(null);
    useEffect(() => {
        dispatch(setCommonData({ filterLevelandDesti: selectedAll }));

    }, [selectedAll])

    // Optional: useEffect to handle escape key
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') closeModal();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);
    // Prevent scroll behind modal
    useEffect(() => {
        if (selectedCard) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }, [selectedCard]);

    return (
        <div className="relative max-w-7xl mx-auto px-4 py-10">
            {/* Header */}
            <div className="mb-8">
                <h4 className="text-sm font-bold text-[#EA1D2A] uppercase">
                    {apiValues?.scholarship?.studyText}

                </h4>
                <h2 className="text-2xl md:text-3xl font-bold text-[#191919] mt-1">{apiValues?.scholarship?.studyDes}</h2>
            </div>

            {/* Study Levels */}
            <div className="mb-10">
                <h3 className="text-lg font-semibold text-[#1D1753] mb-4">{apiValues?.scholarship?.studyLevelText}   </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5">
                    {/* {studyLevels.map((item, idx) => ( */}

                    {

                        (Array.isArray(apiValues?.levels) ? apiValues?.levels : []).map((item: any, index: number) => {

                            return (
                                <Card key={index} emoji={item.levelImage} label={item.levelName}
                                    heightVal={48}
                                    widthval={48}
                                    onClick={() => setSelectedCard(item)} />
                            )

                        }) || []

                    }
                </div>
            </div>

            {/* Study Destinations */}
            <div>
                <h3 className="text-lg font-semibold text-[#1D1753] mb-4">{apiValues?.scholarship?.studyDestiText}</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5">
                    {/* {studyDestinations.map((item, idx) => ( */}
                    {

                        (Array.isArray(apiValues?.destinations) ? apiValues?.destinations : []).map((item: any, index: number) => {

                            return (
                                <Card key={index} emoji={item.countryImage} label={item.countryName}
                                    destination={true}
                                    heightVal={40}
                                    widthval={40}
                                    onClick={() => setSelectedCard(item)} />
                            )

                        }) || []

                    }
                </div>
            </div>

            {/* Responsive Popup Modal */}

            <FilterPopup
                apiValues={apiValues}
                selectedCard={selectedCard}
                closeModal={() => setSelectedCard(null)}
                onApplyFilters={(filters) => {
                    const safeFilters = {
                        countries: filters?.destinations ?? [],
                        levels: filters?.levels ?? [],
                    };
                    setSelectedAll(safeFilters);
                }}

            />


        </div>
    );
};

export default ScholarshipsBrowse;
